export default __webpack_public_path__ + "static/media/marionette.8421d5f4.svg";